export default "__VITE_ASSET__217999f4__"